import { colors } from '@cabonline/ui-shared';
import styled from '@emotion/styled';

import { Button } from '../button';

/**
 * Danger-styled button for destructive confirmations (red background).
 * Internal to the modal package — not exported from ui-web index.
 */
export const StyledDangerButton = styled(Button)`
  && {
    background-color: ${colors.red};
    border-color: ${colors.red};
    color: ${colors.white};

    &:hover:not(:disabled) {
      background-color: ${colors.redDark};
      border-color: ${colors.redDark};
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;
